import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const DNBMDProvider = (props) => {
  const api = new API();
  const [formEditDNBMD] = Form.useForm();
  const [fetchDNBMDList, setFetchDNBMDList] = useState([]);
  const [corentPage, setCorentPage] = useState(1);
  const [tableFilter, setTableFilter] = useState({
    name: '',
    subcategory_id: null,
    subject_id: null,
    page: 1,
    limit: 20
  });
  const [loader,setLoader] = useState({
    table: false,
    subdropdown: false,
    subcatdropdown:false,
    add: false,
    edit: false,
    view: false,
    list: false,
    update: false,
    delete: false,
    relatedmcqs: false,
    subjectmcqs: false
  });
  const [viewScreenDNBMD, setViewScreenDNBMD] = useState({
    add:false,
    edit:false,
    view:false,
    list:true,
    editsnap:false,
    
  });
  const [subjectDropDown,setSubjectDropDown] = useState([]);
  const [subCategoryDropDown,setSubCategoryDropDown] = useState([]);
  const [DNBMDList,setDNBMDList] = useState([]);
  const [DNBMDSingle,setDNBMDSingle] = useState({});
  const [singleDNBMDId,setSingleDNBMDId] = useState("");
  const [relatedMcqs,setRelatedMcqs] = useState([]);
  const [relatedSubject,setRelatedSubject] = useState([]);
  const [selectSubject,setSelectSubject] = useState([]);
  const [addDNBMDForm,setAddDNBMDForm] = useState({
    question_name: "",
    question_description: "",
  })
  const [DNBMDCatLoader, setDNBMDCatLoader] = useState(false);
  const [DNBMDCatList, setDNBMDCatList] = useState([]);
  const [DNBMDCatTableFilter, setDNBMDCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [DNBMDSubCatLoader, setDNBMDSubCatLoader] = useState(false);
  const [DNBMDSubCatList, setDNBMDSubCatList] = useState([]);
  const [DNBMDSubCatTableFilter, setDNBMDSubCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });

  const [appSettings1,setAppSettings1] = useState({});
  const [appSettingsLoading1,setAppSettingsLoading1] = useState(false);
  const [appSettingsULoading1,setAppSettingsULoading1] = useState(false);
  const [updateName1,setUpdateName1] = useState("");
  const [DNBMDTopicLoader, setDNBMDTopicLoader] = useState(false);
  const [DNBMDTopicList, setDNBMDTopicList] = useState([]);
  const [bulkActionDNBMDExam, setBulkActionDNBMDExam] = useState([]);
  const [bulkActionDNBMDExamLoader, setBulkActionDNBMDExamLoader] = useState(false);
  const [bulkActionDNBMDType, setBulkActionDNBMDType] = useState(false);

  const fetchDNBMDSubCatList = async (id) => {
    setDNBMDSubCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/subcategorylist/list", { ...DNBMDSubCatTableFilter, id: id }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDSubCatList(res?.data?.data);
          setDNBMDSubCatLoader(false);
        } else {
          setDNBMDSubCatList([]);
          setDNBMDSubCatLoader(false);
        }
      });
  }
  const fetchDNBMDCatList = async () => {
    setDNBMDCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("dnbmd/categorylist/list", { ...DNBMDCatTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setDNBMDCatList(res?.data?.data);
          setDNBMDCatLoader(false);
        } else {
          setDNBMDCatList([]);
          setDNBMDCatLoader(false);
        }
      });
  }
  const getAppSettings1 = async () => {
    if (localStorage.getItem("rxdx_admin_login") === "true") {
      setAppSettingsLoading1(true);
      try {
        const res = await api.getAll("dnbmd/appsettings", {});
        if (res?.data?.status === 200) {
          setAppSettings1(res?.data?.data);
          setUpdateName1(res?.data?.data?.DNBMD_name);
        } else {
          setAppSettings1({});
        }
      } catch (err) {
        setAppSettings1({});
      } finally {
        setAppSettingsLoading1(false);
      }
    }
  }  
  const updateAppSettings1 = async (DNBMD_name) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setAppSettingsULoading1(false);
      (await api.create("dnbmd/appsettings", {
        DNBMD_name:DNBMD_name
      }, (err, res) => {
        if (res?.data?.status === 200) {
          getAppSettings1();
          setAppSettingsULoading1(false);
        } else {
          setAppSettingsULoading1(false);
        }
      }));
  }
  const fetchDNBMDTable = async (scid,cid) => {
    setLoader({
      ...loader,
      table: true
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmd/subjectwise", { ...tableFilter,subcategory_id:scid,category_id:cid }, (err, res) => {
        if (res?.data?.status === 200) {
          setFetchDNBMDList(res?.data?.data);
        } else {
          setFetchDNBMDList([]);
        }
        setLoader({
          ...loader,
          table: false
        });
      }));
  };

  const loadSSubjectDropdown = async () => {
    setLoader({
      ...loader,
      subdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("subjectmaster/dropdown", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubjectDropDown(res?.data?.data);
        } else {
          setSubjectDropDown([]);
        }
        setLoader({
          ...loader,
          subdropdown: false
        })
      }))
  }

  const loadSubCategoryDropdown = async () => {
    setLoader({
      ...loader,
      subcatdropdown: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("categorymaster/dropdownsub", {}, (err, res) => {
        if(res?.data?.status === 200) {
          setSubCategoryDropDown(res?.data?.data);
        } else {
          setSubCategoryDropDown([]);
        }
        setLoader({
          ...loader,
          subcatdropdown: false
        })
      }))
  }

  const addNewDNBMD = async (data,scid,sid,resetAdd) => {
    setLoader({
      ...loader,
      add: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("subject_id", sid);
    formData.append("topic_id", data?.topic_id);
    formData.append("subcategory_id", scid);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("dnbmd", formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setAddDNBMDForm({
            question_name: "",
            question_description: "",
          })
          resetAdd();
          getDNBMDAll(scid,sid,corentPage);
        }
        setLoader({
          ...loader,
          add: false
        })
      }))
  }

  const getDNBMDAll = async (scid, sid,page=1,limit=100) => {
    setLoader({
      ...loader,
      list: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmd", {subcategory_id: scid, subject_id: sid,page:page,limit:limit}, (err, res) => {
        if(res?.data?.status === 200) {
          setDNBMDList(res?.data?.data);
        } else {
          setDNBMDList([]);
        }
        setLoader({
          ...loader,
          list: false
        })
      }))
  }

  const getSingleDNBMD = async (id) => {
    setViewScreenDNBMD({
      ...viewScreenDNBMD,
      list: false,
      add: false,
      view: true
    })
    setLoader({
      ...loader,
      view: true
    })
    formEditDNBMD.resetFields();
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getSingle("dnbmd/single", id, (err, res) => {
        if(res?.data?.status === 200) {
          fetchRelatedMcqs(res?.data?.data?.subject_id?._id);
          setDNBMDSingle(res?.data?.data);
          setSingleDNBMDId(res?.data?.data?._id);
          formEditDNBMD.setFieldsValue(res?.data?.data);
        } else {
          setDNBMDSingle({});
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          view: false
        })
      }))
  }

  const updateDNBMD = async (data, id, scid, sid, resetEdit) => {
    setLoader({
      ...loader,
      update: true
    })
    const formData = new FormData();
    formData.append("question_name", data?.question_name);
    formData.append("question_description", data?.question_description);
    formData.append("reference", data?.reference);
    formData.append("plan", data?.plan);
    formData.append("topic_id", data?.topic_id);
    if (data.tag_question) {
      data.tag_question.forEach(function(tag) {
        formData.append("tag_question[]", tag);
      });
    }
    if (data.tag_subject) {
      data.tag_subject.forEach(function(tag) {
        formData.append("tag_subject[]", tag);
      });  
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      // (await api.update("dnbmd", id, formData, (err, res) => {
        (await api.update("duplicate/dnbmdupdate", id, formData, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          resetEdit();
          getDNBMDAll(scid, sid,corentPage);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setLoader({
          ...loader,
          update: false
        })
      }))
  }

  const deleteDNBMD = async (id, scid, sid) => {
    setLoader({
      ...loader,
      delete: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("dnbmd", id, (err, res) => {
        if(res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setViewScreenDNBMD({
            ...viewScreenDNBMD,  
            add: false,
            view: false,
            edit: false,
            update: false,
            list: true,
          })
          getDNBMDAll(scid, sid);
        }
        setLoader({
          ...loader,
          delete: false
        })
      }))
  }

  const scrollToTopViewDNBMD = (id) => {
    document.getElementById(`question_order_${id}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }

  const fetchRelatedSubject = async () => {
    setLoader({
      ...loader,
      subjectmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmd/subjectlist",{}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedSubject(res?.data?.data);
        } else {
          setRelatedSubject([]);
        }
        setLoader({
          ...loader,
          subjectmcqs: false
        })
      }))
  }
  function dangerouslySetInnerHTMLToText(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }
  const fetchRelatedMcqs = async (e) => {
    setRelatedMcqs([]);
    setLoader({
      ...loader,
      relatedmcqs: true
    })
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmd/questiontag", {subject_id: e}, (err, res) => {
        if(res?.data?.status === 200) {
          setRelatedMcqs(
            (res?.data?.data ?? []).map((mcq) => ({
              value: mcq?.value,
              label: mcq.label ? (
                dangerouslySetInnerHTMLToText(mcq.label)
              ) : null
            }))
          );
          
        } else {
          setRelatedMcqs([]);
        }
        setLoader({
          ...loader,
          relatedmcqs: false
        })
      }))
  }
  const fetchTopicDNBMD = async (e) => {
    setDNBMDTopicList([]);
    setDNBMDTopicLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("dnbmd/topiclist/list", {subject_id: e}, (err, res) => {
        if(res?.data?.status === 200) {
          setDNBMDTopicList(res?.data?.data);
          
        } else {
          setDNBMDTopicList([]);
        }
        setDNBMDTopicLoader(false);
      }))
  }

  const bulkActionDNBMD = async (ids = [], action = null,scid=null, sid=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionDNBMDExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action_dnbmd", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          scid && sid && getDNBMDAll(scid, sid);
          setBulkActionDNBMDExam([]);
          setBulkActionDNBMDExamLoader(false);
        } else {
          setBulkActionDNBMDExamLoader(false);
        }
      });
  }

   return (
    <Context.Provider value={{
      ...props,
      fetchDNBMDList,
      fetchDNBMDTable,
      setFetchDNBMDList,
      tableFilter,
      setTableFilter,
      loader,
      subjectDropDown,
      loadSSubjectDropdown,
      loadSubCategoryDropdown,
      subCategoryDropDown,
      addDNBMDForm,
      setAddDNBMDForm,
      addNewDNBMD,
      viewScreenDNBMD,
      setViewScreenDNBMD,
      getDNBMDAll,
      setDNBMDList,
      DNBMDList,
      getSingleDNBMD,
      DNBMDSingle,
      setDNBMDSingle,
      formEditDNBMD,
      singleDNBMDId,
      setSingleDNBMDId,
      updateDNBMD,
      deleteDNBMD,
      scrollToTopViewDNBMD,
      fetchRelatedMcqs,
      relatedMcqs,
      relatedSubject,
      setRelatedSubject,
      fetchRelatedSubject,
      selectSubject,
      setSelectSubject,
      setRelatedMcqs,
      appSettings1,setAppSettings1,
      appSettingsLoading1,setAppSettingsLoading1,
      appSettingsULoading1,setAppSettingsULoading1,
      updateAppSettings1,
      getAppSettings1,
      updateName1,setUpdateName1,
      fetchDNBMDCatList,
      DNBMDCatLoader, setDNBMDCatLoader,
      DNBMDCatList, setDNBMDCatList,
      DNBMDCatTableFilter, setDNBMDCatTableFilter,
      fetchDNBMDSubCatList,
      DNBMDSubCatLoader, setDNBMDSubCatLoader,
      DNBMDSubCatList, setDNBMDSubCatList,
      DNBMDSubCatTableFilter, setDNBMDSubCatTableFilter,
      fetchTopicDNBMD,
      DNBMDTopicLoader, setDNBMDTopicLoader,
      DNBMDTopicList, setDNBMDTopicList,
      corentPage, setCorentPage,
      bulkActionDNBMD,
        bulkActionDNBMDExam, setBulkActionDNBMDExam,
        bulkActionDNBMDExamLoader, setBulkActionDNBMDExamLoader,
        bulkActionDNBMDType, setBulkActionDNBMDType,
    }}>
      {props.children}
    </Context.Provider>
   ) 
};

export default DNBMDProvider;